import React from "react";


export default function PurchaseGuide () {
    return(
        <div>Purchase guide</div>
    )
}